import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

class ReimbursementModel {
    private static sInstance: ReimbursementModel;

    public static get instance(): ReimbursementModel {
        if (!ReimbursementModel.sInstance) {
            ReimbursementModel.sInstance = new ReimbursementModel();
        }

        return ReimbursementModel.sInstance;
    }

    private storeUserPermissionMap = TCBReceiptApi.Protobuf.StoreUserPermissionMap.create();
    private reimbursementSummary = TCBReceiptApi.Protobuf.ReimbursementSummary.create();
    private reconciliationList = TCBReceiptApi.Protobuf.ReconciliationList.create();
    private reimbursementCollectionMap = TCBReceiptApi.Protobuf.ReimbursementCollectionMap.create();
    private reimbursementCollection = TCBReceiptApi.Protobuf.ReimbursementCollection.create();
    private reimbursementTotal = TCBReceiptApi.Protobuf.ReimbursementTotal.create();

    // 搜尋 - 特店清單
    public async getStoreSearch(storeInsertQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/reimbursement/get_store_list_by_tid_number",
            "post",
            storeInsertQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.storeUserPermissionMap = TCBReceiptApi.Protobuf.StoreUserPermissionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 搜尋 - 特約商店請款交易查詢
    public async getReimbursement(reimbursementQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/reimbursement/get_store_list_by_condition",
            "post",
            reimbursementQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.reconciliationList = TCBReceiptApi.Protobuf.ReconciliationList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 取得卡別彙總
    public async getReimbursementSummary(
        reimbursementQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/reimbursement/get_summary_by_condition",
            "post",
            reimbursementQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.reimbursementSummary = TCBReceiptApi.Protobuf.ReimbursementSummary.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 搜尋 - 展開前三筆資料之map
    public async getReimbursementCollectionMap(
        reimbursementQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/reimbursement/get_by_condition",
            "post",
            reimbursementQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.reimbursementCollectionMap = TCBReceiptApi.Protobuf.ReimbursementCollectionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 搜尋 - 取得展開資料 (單一筆)
    public async getReimbursementCollection(
        reimbursementQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/reimbursement/get_specific_by_condition",
            "post",
            reimbursementQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.reimbursementCollection = TCBReceiptApi.Protobuf.ReimbursementCollection.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 搜尋 - 統計
    public async getReimbursementTotal(
        reimbursementQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/reimbursement/get_total_by_condition",
            "post",
            reimbursementQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                console.log("response");
                console.log(response);
                this.reimbursementTotal = TCBReceiptApi.Protobuf.ReimbursementTotal.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    /* ----列印頁面---- */
    public async getPrintReimbursementCollectionMap(
        reimbursementQuery: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ReimbursementCollectionMap> {
        let map = TCBReceiptApi.Protobuf.ReimbursementCollectionMap.create();

        await Network.sendAPI(
            "/api/front/reimbursement/get_print_by_condition",
            "post",
            reimbursementQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                map = TCBReceiptApi.Protobuf.ReimbursementCollectionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });

        return map;
    }
    /* ----列印頁面---- */    

    // 取得特店清單列表
    public getStoreList(): TCBReceiptApi.Protobuf.StoreUserPermissionMap {
        return this.storeUserPermissionMap;
    }

    // 取得搜尋結果 - 列表
    public getReimbursementList(): TCBReceiptApi.Protobuf.ReconciliationList {
        return this.reconciliationList;
    }

    // 取得卡別彙總
    public getReimbursementSummaryData(): TCBReceiptApi.Protobuf.ReimbursementSummary {
        return this.reimbursementSummary;
    }

    // 取得搜尋結果 - 展開資料map (前三筆)
    public getReimbursementCollectionMapData(): TCBReceiptApi.Protobuf.ReimbursementCollectionMap {
        return this.reimbursementCollectionMap;
    }

    // 取得搜尋結果 - 取得展開資料 (單一筆)
    public getReimbursementCollectionData(): TCBReceiptApi.Protobuf.ReimbursementCollection {
        return this.reimbursementCollection;
    }

    // 取得搜尋結果 - 統計
    public getReimbursementTotalObj(): TCBReceiptApi.Protobuf.ReimbursementTotal {
        return this.reimbursementTotal;
    }

    // 取得請款匯出
    public async exportReimbursement(queryString: string): Promise<void> {
        const uri = "/api/front/reimbursement/get_export_by_condition?" + queryString;
        await Network.downloadFile(uri);
    }    

    public async getReportList(): Promise<TCBReceiptApi.Protobuf.ScheduleReportList> {
        const list = TCBReceiptApi.Protobuf.ScheduleReportList.create();

        // await Network.sendAPI(
        //     "/api/front/reimbursement/report/get_report_list",
        //     "post"
        // )
        //     .then((rawResponse) => {
        //         const response = TCBReceiptApi.Protobuf.Response.decode(
        //             new Uint8Array(rawResponse.data as ArrayBufferLike)
        //         );

        //         list = TCBReceiptApi.Protobuf.ScheduleReportList.decode(
        //             new Uint8Array(response.item)
        //         );
        //     })
        //     .catch((error) => {
        //         Log.error(error);
        //     });

        return list;
    }

    public async downloadFile(queryString: string): Promise<void> {
        const uri = "/api/front/reimbursement/get_file?" + queryString;
        await Network.downloadFile(uri);
    }
}

const reimbursementModel = ReimbursementModel.instance;

export { reimbursementModel as ReimbursementModel };
